import { FormEvent, ReactElement, useCallback, useContext, useMemo, useState } from "react"
import { FranchiseModel } from "../../../data/entity/franchise-model"
import logoPositivo from '../../assets/logo-positivo.webp'
import { FranchiseContext } from "../../context/franchise-context/franchise-context"
import { HamburguerButton } from '../hamburguer-button/hamburguer-button'
import { LandingpageType } from "../home/home"
import { Link } from "../link/link"
import { LogoAmorSaude } from "../logo/amor-saude"
import { HeaderProps } from "./header-props"
import * as S from './header-style'

enum MenuState {
  OPEN,
  CLOSE
}

export function Header (props: HeaderProps): ReactElement {
  const [menuState, setMenuState] = useState<MenuState>(MenuState.CLOSE)
  const franchise = useContext<FranchiseModel>(FranchiseContext)
  const menuItems = useMemo(() => franchise.sections.filter((section) => section.menu), [franchise.sections])
  const handleHamburguer = useCallback((evt: FormEvent<HTMLDivElement>) => {
    if (menuState === MenuState.OPEN) {
      setMenuState(MenuState.CLOSE)
      return
    }

    setMenuState(MenuState.OPEN)
  }, [menuState])
  return <S.Container>
    <S.LogoRegion>
      <S.Logo src={logoPositivo} alt="Cartão de todos" />
      {franchise.type === LandingpageType.DIGITAL && <>
        <S.Divider />
        <LogoAmorSaude />
      </>}
    </S.LogoRegion>
    <S.Menu $open={menuState === MenuState.OPEN}>
      {menuItems.map(section => <li>
        <a href={`#${section.id}`} onClick={() => setMenuState(MenuState.CLOSE)}>{section.name}</a>
      </li>)}
    </S.Menu>
    {franchise.type === LandingpageType.PHYSICAL && <S.ButtonContainer>
      <Link href={props.urlBuilder.build(franchise.mainLink, props.params)}>Peça seu cartão</Link>
      <HamburguerButton onClick={handleHamburguer} />
    </S.ButtonContainer>}
  </S.Container>
}